// @flow
/* npm modules outside of vrbo */
import React from 'react';
import type {Element, ComponentType} from 'react';

/* style */
import './Card.less';

type Props = {
    bottom: Element<*>,
    cardWrapperTagName: ComponentType<*>,
    cardWrapperTagNameProps: Object,
    leftTagNameProps?: Object,
    topLeft: Element<*>,
    topRight?: Element<*>,
    leftTagName: string,
};

export const Card = ({
    bottom,
    cardWrapperTagName: CardWrapperTagName,
    cardWrapperTagNameProps,
    leftTagName: LeftTagName,
    leftTagNameProps,
    topLeft,
    topRight,
}: Props) => {
    const className = `Card__${topRight ? 'horizontal' : 'vertical'}`;
    return (
        <CardWrapperTagName className={className} {...cardWrapperTagNameProps}>
            <div className="top">
                <LeftTagName className="left" {...leftTagNameProps}>
                    {topLeft}
                </LeftTagName>
                {topRight && <div className="right">{topRight}</div>}
            </div>
            <div className="bottom">{bottom}</div>
        </CardWrapperTagName>
    );
};
